module.exports = __webpack_public_path__ + "img/grand-room-5.70d18af9.jpg";